import React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

import Hero from "../components/Hero"
import Features from "../components/Features"

const IndexPage = () => (
  <>
    <Helmet>
      <title>Home | au et chiu Import Export</title>
      <link rel="canonical" href="https://auetchiu.com" />
    </Helmet>
    <div className="o-section o-grid">
      <Hero />
      <Features />
      <div className="o-grid__item--center">
        <div className="c-button__container">
          <Link to="/contact">
            <button className="c-button c-button--cta">contact us</button>
          </Link>
        </div>
      </div>
    </div>
  </>
)

export default IndexPage
